document.documentElement.classList.add('drop-js');

const cultureEvents = (name, detail = {}) => {
  document.dispatchEvent(new CustomEvent('culture:event', { detail: { name, ...detail } }));
  window.dataLayer?.push({ event: `culture_${name}`, ...detail });
};

const observer = 'IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ? new IntersectionObserver((entries, instance) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        instance.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' })
  : null;

document.querySelectorAll('[data-drop-reveal]').forEach((element) => {
  if (observer) observer.observe(element);
  else element.classList.add('is-visible');
});

document.addEventListener('click', (event) => {
  const target = event.target.closest('[data-culture-event]');
  if (!target) return;
  cultureEvents(target.dataset.cultureEvent, {
    product_id: target.dataset.productId || undefined,
    destination: target.getAttribute('href') || undefined
  });
});

document.addEventListener('click', (event) => {
  if (event.target.closest('[data-size-guide], a[href*="size"]')) cultureEvents('size_guide_open');
});

if (document.querySelector('[data-template*="product"]')) {
  cultureEvents('product_view', { product_id: document.querySelector('product-form [name="product-id"]')?.value });
}

if (document.querySelector('[data-template*="cart"]')) cultureEvents('cart_view');

const collectionMain = document.querySelector('[data-template*="collection"]');
const collectionDescription = collectionMain?.querySelector('.section .rte');
if (collectionDescription) {
  const descriptionWords = collectionDescription.innerText.trim().split(/\s+/);
  if (descriptionWords.length > 45) {
    collectionDescription.textContent = `${descriptionWords.slice(0, 45).join(' ')}…`;
    collectionDescription.classList.add('collection-description-short');
  }
}

document.addEventListener('submit', (event) => {
  if (event.target.matches('product-form form, form[action*="/cart/add"]')) {
    const data = new FormData(event.target);
    cultureEvents('add_to_cart_attempt', { variant_id: data.get('id') || undefined });
  }
  if (event.target.matches('form[action*="/search"]')) {
    const data = new FormData(event.target);
    cultureEvents('search_submit', { search_term: data.get('q') || undefined });
  }
});

document.addEventListener('change', (event) => {
  const field = event.target;
  if (field.matches('product-form select, product-form input[type="radio"]')) {
    cultureEvents('variant_change', { option: field.name, value: field.value });
  }
  if (field.closest('facets-form, .facets')) {
    cultureEvents('filter_change', { filter: field.name, value: field.value });
  }
});
